module.exports = __webpack_public_path__ + "static/026-d57d3fc512e4472818a96dc1e6e50492.jpg";